// This address points to a dummy ERC-20 contract. Replace it with your own smart contracts.
const addresses = {
  kanji: "0xa9D1D6bdf8B8B42F249C0C791e372e105537cFBa",
};
export default addresses;
